











































































































































































































































































































































































































































































































































































































































































































































































import {Component, Prop, Vue, Model, Watch} from "vue-property-decorator";
import moment from "moment";
import { get, post } from "@/util/request";
import UpdateTaskForm from "./components/UpdateTaskFormRole.vue";
import DistributionMenu from "./components/DistributionMenu.vue";
import PickCoordinate from "@/components/map/pickCoordinate.vue";
import PickCoordinate1 from "@/components/map/pickCoordinate1.vue";
import Calibration from '@/components/device/calibration.vue';
import org from "@/util/org";
import axios from "axios";
import { jsonp }  from 'vue-jsonp'
import any = jasmine.any;


const statusMap = ["default", "processing", "success", "error"];
const status = ["关闭", "运行中", "已上线", "异常"];

@Component({
  components: {
    UpdateTaskForm,
    DistributionMenu,
    PickCoordinate,
    PickCoordinate1,
    Calibration
  }
})
export default class devicesBasic extends Vue {
  private editMapFlag: boolean = false
  private typeOperation: string = ''
  private serch: any = {
    name: ""
  };

  private searchFormLayout: any = {
    labelCol: {
      span: 5
    },
    wrapperCol: {
      span: 18,
      offset: 1
    }
  };
  private form: any = {};

  @Watch("serch.name")
  private watchsearchInform(newVal: string, oldval: string) {
    if (newVal === '') {
      this.current = 1
    }
    this.handleSearch();
  }

  private editBeforeData: any = {
    id: '',
    name: '',
    mac: '',
    longitude: '',
    latitude: '',
    version: {
      id: '',
      name: ''
    },
    operators: null,
    installTime: '',
    createTime: '',
    monitorPoint: {
      id: '',
      name: ''
    },
    profession: {
      id: '',
      name: ''
    },
    tech: {
      id: '',
      name: ''
    },
    detector: {
      id: '',
      name: ''
    },
    purchaser: {
      id: '',
      name: ''
    },
    address: '',
    extand: {
      area: '',
      speed: ''
    },
    positionBack: [],
    guid: undefined,
    town: {
      townCode: 0,
      townName: ''
    }
  }

  private expandForm: boolean = false;

  private selectedRowKeys: any[] = [];

  private selectedRows: any[] = [];

  private tableLoading: boolean = false;

  private moment: any = moment;

  private dataSource: any[] = [];

  private model: any[] = []; //设备型号
  private operators: any[] = []; //维护人
  private MonitorPoints: any[] = []; //所有站点
  private Professions: any[] = []; //行业
  private Techs: any[] = []; //所有工艺
  private Detectors: any[] = []; // 所有设备检测器
  private Purchasers: any[] = []; //所有采购商
  private town_code!: number // 新增设备的经纬度区域code用于新增

  private visibleCreateModal: boolean = false;

  private editTaskFormVisible: boolean = false;

  private distributionMenuVisible: boolean = false;

  private createForm: any = null;

  private editRecord: any = {};
  private pagination: any = {
    total: 0,
    current: 1,
    pageSize: 5,
    showSizeChanger: false,
    showQuickJumper: false
  };

  private updateRecord1: any = {};

  private columns: any[] = [
    {
      title: "名称",
      dataIndex: "name"
    },
    {
      title: "mac",
      dataIndex: "mac"
    },
    {
      title: "型号",
      dataIndex: "version.name"
    },
    {
      title: "监控站点",
      dataIndex: "monitorPoint.name"
    },
    {
      title: "政府站点",
      dataIndex: "govMonitorPoint.name"
    },
    {
      title: "维护人",
      dataIndex: "operators"
    },
    {
      title: "生产时间",
      dataIndex: "createTime"
    },
    {
      title: "安装时间",
      dataIndex: "installTime"
    },
    {
      title: "操作",
      customRender: this.opRender
    }
  ];
  // 存放地理位置信息
  private areaData: any = JSON.parse(JSON.stringify(org))

  constructor() {
    super();
  }

  get status() {
    return status;
  }

  get statusMap() {
    return statusMap;
  }

  get statuFilters() {
    return [
      {
        text: status[0],
        value: 0
      },
      {
        text: status[1],
        value: 1
      },
      {
        text: status[2],
        value: 2
      },
      {
        text: status[3],
        value: 3
      }
    ];
  }

  private startTime: any = null;
  private endTime: any = null;

  //规则指定
  private rules: any = {
    name: [
      {required: true, message: '名称不能为空', trigger: ['change', 'blur']},
    ],
    mac: [
      {required: true, message: 'mac不能为空', trigger: ['change', 'blur']},
    ],
    monitorPoint: {
      id:[
        {required: true, message: '监控站点不能为空', trigger: ['change', 'blur']},
      ],
    },
    version: {
      id: [
        {required: true, message: '设备型号不能为空', trigger: ['change', 'blur']},
      ]
    },
    longitude: [
          {message: '请输入正确的经度',pattern:/^[+-]?\d+(\.\d+)?$/}
          ],
    latitude: [
      {message: '请输入正确的纬度',pattern:/^[+-]?\d+(\.\d+)?$/}
    ],
    profession: [
      {required: true, message: '所选行业不能为空', trigger: ['change', 'blur']},
    ],
    address: [
      {required: true, message: '位置信息不能为空'},
    ],
    town: {
      townName: [
        {required: true, message: '行政区划不能为空'},
      ]
    }

  }

//date-picker时间转换
  private onStartTimeChange(date: any, dateString: any) {
    this.startTime = dateString;
  }

  private onEndTimeChange(date: any, dateString: any): void {
    this.endTime = dateString;
  }


  private addMapFlag: boolean = false

  private showMap1() {
    this.typeOperation = 'add'
    this.addMapFlag = true
  }
  private showMap2() {
    this.editMapFlag = true
  }
  // 定位级别数据
  private positionLevel(val: any) {
    var code = val[val.length-1]
    this.getGovPointByArea(code)
  }


  // 存放国控站点数据
  private govMonitors: any[] = []
  // 根据定位级别获取政府站点
  private getGovPointByArea(code: any) {
    get('govMonitorPoint/govMonitorPoints', {
        regionCode: code
    }).then((res: any) => {
      if (res.data.code === 0) {
        this.govMonitors = res.data.data
      }
    })
  }

//新建选择框，查询功能
  filterOption(input: any, option: any) {
    return (
        option.componentOptions.children[0].text
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0
    );
  }

  private mounted() {
    this.getDropDownData()
  }

  // 初始下拉框数据加载
  private getDropDownData() {
    //初始加载型号
    get("device/versions", {})
        .then(res => {
          this.model = res.data.data.reverse();
        })
        .catch(err => {
          console.log(err);
        });
    //初始加载维护人
    get("device/operators", {})
        .then(res => {
          this.operators = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });

    //初始加载所有站点
    get("device/allMonitorPoint", {})
        .then(res => {
          this.MonitorPoints = res.data.data.reverse();
        })
        .catch(err => {
          console.log(err);
        });

    //初始加载行业
    get("device/professions", {})
        .then(res => {
          this.Professions = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });

    //初始加载所有工艺
    get("device/techs", {})
        .then(res => {
          this.Techs = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });

    //初始加载所有设备检测器
    get("device/detectors", {})
        .then(res => {
          this.Detectors = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });

    //初始加载所有设备检测器
    get("device/purchasers", {})
        .then(res => {
          this.Purchasers = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });

  }

  //新建按钮。
  private handleModalVisible(isVisible: boolean): void {
    this.visibleCreateModal = isVisible;
    this.getGovPointByArea('')
    this.techFlag = false
  }

  private toggleForm(): void {
    this.expandForm = !this.expandForm;
  }

  private handleFormReset(): void {
    this.serch.name = null;
    this.loadRuleData(1);
  }

  private handleSearch(): void {
    this.current = 1
    this.loadRuleData(this.current)
  }

  private current: number = 1
  private handlerTableChange(pagination: any, filter: any, sorter: any): void {
    this.current = pagination.current
    this.loadRuleData(pagination.current)
  }


  private selectOrg: any = null
  //下拉查询框方法
  private handleChange(selectedItems:any) {
    if (selectedItems === undefined) {
      this.selectOrg = null
    }else {
      this.selectOrg = selectedItems;
    }
    this.loadRuleData(1)
  }

  private selectMt: any = null

  //下拉查询框方法
  private handleChange1(selectedItems:any) {
    if (selectedItems === undefined) {
      this.selectMt = null
    }else {
      this.selectMt = selectedItems;
    }
    this.loadRuleData(1)
  }



  private editTechFlag:boolean = false

  private selectMaintainer: any = []

  private editTech(key: any) {
    if (key === 0) {
      this.editTechFlag = true
      this.editBeforeData.extand.area = this.et.area
      this.editBeforeData.extand.speed = this.et.speed
    }else {
      this.editTechFlag = false
    }
  }

  private et: any = {
    area: '',
    speed: ''
  }

  private testRecord: any = null
  // 编辑动态绑定数据
  private handleEditModalVisible(visible: boolean, record: any): void {
    this.getGovPointByArea('')
    this.selectMaintainer = []
    this.testRecord = record
    for (let i = 0; i < this.maintainer.length; i++) {
      if (record.id === this.maintainer[i].id) {
        if (this.maintainer[i].m.length !== 0) {
          for (let j = 0; j < this.maintainer[i].m.length; j++) {
            this.selectMaintainer.push((this.maintainer[i].m[j].id))
          }
        }
      }
    }

    this.editRecord = record
    // if (this.editRecord.tech === '0') {
    //   this.extend = {
    //
    //   }
    // }
    const professionIds = record.professions.map((item: any) => {
      return item.dataKey
    })
    this.editBeforeData.id = record.id
    this.editBeforeData.name = record.name
    this.editBeforeData.mac = record.mac
    this.editBeforeData.version.id = record.version.id
    this.editBeforeData.version.name = record.version.name
    this.editBeforeData.longitude = record.longitude
    this.editBeforeData.latitude = record.latitude
    this.editBeforeData.operators = record.operators
    this.editBeforeData.installTime = record.installTime
    this.editBeforeData.createTime = record.createTime
    this.editBeforeData.monitorPoint.id = record.monitorPoint.id
    this.editBeforeData.monitorPoint.name = record.monitorPoint.name
    this.editBeforeData.profession.id = record.professions === null || record.professions === '' || record.professions === undefined  ? undefined : professionIds
    this.editBeforeData.town.townName = record.town.townName
    this.editBeforeData.town.townCode = record.town.townCode
    // this.editBeforeData.profession.name = record.professionName
    this.editBeforeData.tech.id = record.tech === null || record.tech === '' ? undefined : Number(record.tech)
    this.editBeforeData.guid = record.govMonitorPoint.guid === null ?  undefined :  record.govMonitorPoint.guid
    if ( this.editBeforeData.tech.id === 0 ){
      this.editTechFlag = true
      if (JSON.parse(record.extend) !== null) {
        this.et.area = JSON.parse(record.extend).area
        this.et.speed = JSON.parse(record.extend).speed
        this.editBeforeData.extand.area = this.et.area
        this.editBeforeData.extand.speed = this.et.speed
      }else {
        this.editBeforeData.extand.area = ''
        this.editBeforeData.extand.speed = ''
      }
    }else {
      this.editTechFlag = false
      this.editBeforeData.extand.area = ''
      this.editBeforeData.extand.speed = ''
    }
    this.editBeforeData.tech.name = record.techName
    this.editBeforeData.detector.id = record.detector === null || record.detector === '' ? undefined : Number(record.detector)
    this.editBeforeData.detector.name = record.detectorName
    this.editBeforeData.purchaser.id = record.purchaser === null || record.purchaser === '' ? undefined : Number(record.purchaser)
    this.editBeforeData.purchaser.name = record.purchaserName
    this.editBeforeData.address = record.address
    this.editTaskFormVisible = true;
  }

  // 编辑保存
  private handleEditModalOk() {

    this.$refs.editRulesForm.validate((valid: any) => {
      if (valid) {
        let stringIds: string = ''
        if (this.selectMaintainer.length !== 0) {
          for (let i = 0; i < this.selectMaintainer.length; i++) {
            stringIds += this.selectMaintainer[i] + ','
          }
          if (stringIds.charAt(stringIds.length - 1) == ",") {
            stringIds = stringIds.slice(0, stringIds.length - 1);
          }
        }

        let maintainerArray = []
        for (let i = 0; i < this.maintainer.length; i++) {
          if (this.testRecord.id === this.maintainer[i].id) {
            if (this.maintainer[i].m.length !== 0) {
              for (let j = 0; j < this.maintainer[i].m.length; j++) {
                maintainerArray.push((this.maintainer[i].m[j].id))
              }
            }
          }
        }
        let orChange = true // 判断
        for (let item = 0; item < this.editRecord.professions.length; item++) {
          if (this.editBeforeData.profession.id.indexOf(this.editRecord.professions[item].dataKey) < 0) {
            orChange = false
            break
          }
        }
        stringIds = JSON.stringify(maintainerArray) === JSON.stringify(this.selectMaintainer) ? null : stringIds
        let name = this.editBeforeData.name === this.editRecord.name ? null : this.editBeforeData.name
        let  mac = this.editBeforeData.mac === this.editRecord.mac ? null : this.editBeforeData.mac
        let address =  this.editBeforeData.address === this.editRecord.address ? null : this.editBeforeData.address
        let longitude = this.editBeforeData.longitude === this.editRecord.longitude ? null : this.editBeforeData.longitude
        let latitude = this.editBeforeData.latitude === this.editRecord.latitude ? null : this.editBeforeData.latitude
        let monitorPointId = this.editBeforeData.monitorPoint.id === this.editRecord.monitorPoint.id ? null : this.editBeforeData.monitorPoint.id
        let deviceVersionId =  this.editBeforeData.version.id === this.editRecord.version.id ? null : this.editBeforeData.version.id
        let createTime = this.editBeforeData.createTime === this.editRecord.createTime ? null : moment(this.editBeforeData.createTime._d).format("YYYY-MM-DD HH:mm:ss")
        let installTime = this.editBeforeData.installTime === this.editRecord.installTime ? null : moment(this.editBeforeData.installTime._d).format("YYYY-MM-DD HH:mm:ss")
        let tech = (this.editBeforeData.tech.id === undefined && this.editRecord.tech === null || this.editBeforeData.tech.id === undefined && this.editRecord.tech === '' ||
            (this.editBeforeData.tech.id === Number(this.editRecord.tech === '' || this.editRecord.tech === null ? undefined : this.editRecord.tech))
        ) ? null : this.editBeforeData.tech.id === undefined ? '' : this.editBeforeData.tech.id
        let profession = orChange ? null : this.editBeforeData.profession.id.join(',')
        let detector = ((this.editBeforeData.detector.id === undefined && this.editRecord.detector === null) || (this.editBeforeData.detector.id === undefined && this.editRecord.detector === '') ||
            (this.editBeforeData.detector.id === Number(this.editRecord.detector === '' || this.editRecord.detector === null ? undefined : this.editRecord.detector))
        ) ? null : this.editBeforeData.detector.id === undefined ? '' : this.editBeforeData.detector.id
        let purchaser = (this.editBeforeData.purchaser.id === undefined && this.editRecord.purchaser === null || this.editBeforeData.purchaser.id === undefined && this.editRecord.purchaser === '' ||
            (this.editBeforeData.purchaser.id === Number(this.editRecord.purchaser === '' || this.editRecord.purchaser === null ? undefined : this.editRecord.purchaser))
        ) ? null : this.editBeforeData.purchaser.id === undefined ? '' : this.editBeforeData.purchaser.id
        let guid = this.editBeforeData.guid === this.editRecord.govMonitorPoint.guid ? null : this.editBeforeData.guid
        let townCode = this.editBeforeData.town.townCode === this.editRecord.town.townCode ? null : this.editBeforeData.town.townCode


        let extend = null
        if (this.editBeforeData.tech.id === 0) {
          if (this.editRecord.extend === null){
            extend = JSON.stringify(this.editBeforeData.extand)
          }else {
                if (JSON.stringify(this.editBeforeData.extand) === JSON.stringify(JSON.parse(this.editRecord.extend))) {
              extend = null
            }else{
              extend = JSON.stringify(this.editBeforeData.extand)
            }
          }
        }else {
          this.editBeforeData.extand = {
            speed:  '',
            area: ''
          }
        }


        if ( !(name || mac || address || longitude || latitude || monitorPointId || deviceVersionId || townCode
            || (profession || profession === 0 || profession === '') || (tech || tech === 0 || tech === '')
            || (detector || detector === 0 || detector === '') || (purchaser || purchaser === 0 || purchaser === '')
            || createTime || installTime || stringIds !== null || extend || guid)){
          this.$message.warning('未修改')
          return ;
        }
        post("device/update", {
          id: this.editBeforeData.id,
          name: name,
          mac: mac,
          address: address,
          longitude: longitude,
          latitude: latitude,
          monitorPointId: monitorPointId,
          deviceVersionId: deviceVersionId,
          profession: profession,
          tech: tech ,
          detector: detector,
          purchaser: purchaser,
          createTime: createTime,
          installTime: installTime,
          operateIds: stringIds,
          extend: extend,
          guid: guid,
          townCode: townCode
        }).then((res: any) => {
          if (res.data.code === 0) {
            this.$message.success("修改成功")
            this.loadRuleData(1);
            this.editTaskFormVisible = false;
          }
        })


      } else {
        console.log('error submit!!');
        return false;
      }
    });


  }

  // 编辑取消
  private handleEditModalCancel() {
    this.editTaskFormVisible = false;
  }

  private resetMonitor(val: any) {
  }

  private handleUpdateModalVisible1(visible: boolean, record: any): void {
    this.updateRecord1 = record;
    setTimeout(() => {
      this.distributionMenuVisible = true;
    }, 500);
  }

  // 存放查询的组织id
  private selectMt: any = null

  //新建保存
  private handleCreateModalOk() {
    this.form.validateFields((err: any, values: any) => {
      if (values.jingdu === '') {
        values.jingdu = this.addLL.lng
      }
      if (err) {
        return;
      }
      let op = '';
      if (values.operator) {
        for (let i = 0; i < values.operator.length; i++) {
          op += values.operator[i] + ",";
        }
        if (op.charAt(op.length - 1) == ",") {
          op = op.slice(0, op.length - 1);
        }
      }

      let industry = ''
      if (values.profession) {
        industry = values.profession.join(',')

      }
      let extend  = null


      if (values.area){
        if (values.speed){
          extend = JSON.stringify({speed: values.speed,area: values.area})
        }else{
          extend = JSON.stringify({area: values.area})
        }
      }else {
        if (values.speed){
          extend = JSON.stringify({speed: values.speed})
        }else{
          extend = null
        }
      }
      post(
              "device/insert",
              {
                name: values.deviceName,
                mac: values.mac,
                address: values.address ? values.address : null,
                longitude: values.jingdu ? values.jingdu : null,
                latitude: values.weidu ? values.weidu : null,
                deviceVersionId: values.model ? values.model : null,
                monitorPointId: values.monitorPoint ? values.monitorPoint : null,
                profession: industry,
                operateIds: op,
                tech: values.tech ? values.tech : null,
                detector: values.detector ? values.detector : null,
                purchaser: values.purchaser ? values.purchaser : null,
                createTime: this.startTime ? this.startTime : null,
                extend: extend,
                installTime: this.endTime ? this.endTime : null,
                guid: values.govMonitor ? values.govMonitor : null,
                townCode: Number(this.town_code)
              }
          )
          .then((res: any) => {
            if (res.data.code !== 0) {
              this.$message.error(res.data.message, 2);
            } else {
              this.visibleCreateModal = false;
              this.addLL = {
                lng: '',
                lat: ''
              }
              this.$message.success(res.data.message)
              this.loadRuleData(1);
            }
          })
          .catch(err => {
            console.log(err);
          });
    });
  }

  private handleUpdateOk() {
    this.loadRuleData(1);
  }

  private handleCreateModalCancel(): any {
    this.addLL = {
      lng: '',
      lat: ''
    }
    this.visibleCreateModal = false;
  }

  private handlerSelectChange(arr1: any, arr2: any) {
    this.selectedRows = arr2;
  }

  private handleMenuClick(e: any) {
  }

  private techFlag:boolean = false
  private changeTech(key: any) {
    if (key === '0' || key === 0) {
      this.techFlag = true
    }else {
      this.techFlag = false
    }
  }

  // 存放添加的经纬度
  private addLL: any = {
    lng : '',
    lat : ''
  }

  private created() {
    this.form = this.$form.createForm(this, {name: "devicesBasic"});
    this.loadRuleData(1);
    this.getAllOrg()
    this.getAllMonitor()
  }

  // 存放维护人信息
  private maintainer: any = []

  private loadRuleData(pageSize: number) {
    this.tableLoading = true;
    get("device/select", {
            organizationId:  this.selectOrg,
            monitorPointId: this.selectMt,
            name: this.serch.name,
            mac: this.serch.name,
            page: pageSize,
            size: 8
        })
        .then(res => {
          if(res.data.code === 0) {
            this.tableLoading = false;
            this.pagination.total = res.data.data.total;
            this.pagination.current = res.data.data.current;
            this.pagination.pageSize = res.data.data.pageSize;
            this.dataSource = res.data.data.item;
            this.maintainer = []
            for (let i = 0; i < this.dataSource.length; i++) {
              let operatorsInform = this.dataSource[i].operators;
              let mObj = operatorsInform
              let obj = {
              }

              obj.id = this.dataSource[i].id
              obj.m = mObj
              this.maintainer.push(obj)
              if (operatorsInform) {
                let op = "";
                for (let j = 0; j < operatorsInform.length; j++) {
                  op += operatorsInform[j].name + "、";
                }
                if (op.charAt(op.length - 1) == "、") {
                  op = op.slice(0, op.length - 1);
                }
                this.dataSource[i].operators = op;
              }
            }
          }else if( res.data.code === 3) {
            this.$message.error(res.data.message,2)
          }else {
            this.$message.warning(res.data.message)
          }

        });
  }


  // 组织数据
  private orgData:any = {}

  // 获得所有组织
  private getAllOrg(){
    get("organization/queryNames",{}).then(res => {
      this.orgData = res.data.data.organizationVOs.reverse()
    })
  }

  // 站点数据
  private monitorData:any = {}
  // 获取所有站点
  private getAllMonitor() {

  }




  private deleteDevice(record: any) {
    get("device/delete", {
            deviceId: record.id
        })
        .then(res => {
          if (res.data.code === 0) {
            this.$message.success(res.data.message)
            this.loadRuleData(1);
          }
        })
        .catch(function (error) {
          console.log("删除失败");
        });
  }


  private mapRecord: any = {}

  //地图URL
  private mapUrl:string = 'device/update'

  private showMap(flag: boolean, record: any) {
    this.mapFlag = flag
    this.mapRecord = record
  }

  private mapFlag: boolean = true

  private receiveFlag(flag: boolean) {
    this.mapFlag = true
  }

  private receiveFlag1(flag: boolean){
    this.addMapFlag = flag
  }

  private receiveFlag2(flag: boolean){
    this.editMapFlag = flag
  }
  // 接收新增经纬度点
  private receiveLomLat(lonLat: any) {
    this.addLL = lonLat
    this.getTownData(lonLat)
  }

  private getTownData(lonLat: any) {
    // jsonp('/proxy/reverse_geocoding/v3/', {
    jsonp('https://api.map.baidu.com/reverse_geocoding/v3/', {
        ak: 'e5ig9Z7AKFjv8wbkqDbuLkUMzBev0tgT',
        output: 'json',
        coordtype: 'wgs8411',
        extensions_town: true,
        location: lonLat.lat+ ',' + lonLat.lng
    }).then((res: any) => {
      if(this.typeOperation === 'add') {
        this.town_code = res.result.addressComponent.town_code
        this.form.setFieldsValue({
          jingdu: this.addLL.lng,
          weidu: this.addLL.lat,
          town: res.result.addressComponent.town
        })
      } else {
        console.log(res);
        if (!(res.result.addressComponent.town === '' && res.result.addressComponent.town_code === '')){
          this.editBeforeData.town.townName = res.result.addressComponent.town
          this.editBeforeData.town.townCode = res.result.addressComponent.town_code
        } else {
          this.editBeforeData.town.townName = res.result.addressComponent.town
          this.editBeforeData.town.townCode = res.result.addressComponent.town_code
          this.$message.warning('选择位置信息异常')
        }

      }
    })
  }
  // 接收修改经纬度点
  private receiveLomLat1(lonLat: any) {
    this.editBeforeData.longitude = lonLat.lng
    this.editBeforeData.latitude = lonLat.lat
    this.getTownData(lonLat)
  }

  @Watch('mapFlag')
  private monitorMapFlag(newVal: boolean, oldVal: boolean) {
    this.mapFlag = newVal
  }

  // 配置校准值----------------------------------------------------------------------------------->>>>>>>>>>>>>>>>>>>>>>>>>

  private visibleFlag: boolean = false
  private caliRecord: any = null
  private showCalibration(record: any) {
    this.visibleFlag = true
    this.caliRecord = record
  }

  private turnFlag(flag: boolean) {
    this.visibleFlag = false
  }
  private opRender(text: string, record: any, index: number) {
    return (
        <div>
          <a onClick={() => this.handleEditModalVisible(true, record)}>
            {" "}
            编辑{" "}
          </a>
          <a-divider type="vertical"/>
          <a-popconfirm
              title="确认删除吗？"
              ok-text="确定"
              cancel-text="取消"
              onConfirm={() => this.deleteDevice(record)}
          >
            <a href="#">删除</a>
          </a-popconfirm>
          <a-divider type="vertical"/>

          <a-dropdown>
            <a class="ant-dropdown-link">
              更多 <a-icon type="down"/></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a onClick={() => this.showCalibration(record)}>配置校准值</a>
              </a-menu-item>
              <a-menu-item>
                <a onClick={() => this.showMap(false, record)}>配置坐标</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
    )
        ;
  }


}
